import { FlexRow, LabeledData } from '@gorila-shared-ui/components';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAsset } from '../../../types/fleet';
import { getAssetTitle } from '../../../utils/assets';

type Props = Readonly<{ asset: FleetAsset }>;

function FleetAssetInlineLabel({ asset }: Props) {
  const { theme } = useStyles();

  return (
    <LabeledData
      label="Para:"
      labelWidth="auto"
      content={
        <FlexRow
          gap={theme.sizing.scale100}
          centered
        >
          <LabelSmall>{getAssetTitle(asset)}</LabelSmall>
          {asset.label && (
            <ParagraphSmall
              margin={0}
              color={theme.colors.contentSecondary}
            >
              {`(${asset.label})`}
            </ParagraphSmall>
          )}
        </FlexRow>
      }
    />
  );
}

export default FleetAssetInlineLabel;
